<template>
    <div class="overview">
        <div class="playerContainer">
            <div class="playerBox">
                <div class="dimension"></div>
                <div class="player line"><span>{{playerA}}</span></div>
                <div class="player"><span>{{playerB}}</span></div>
            </div>
            <div class="playerBox">
                <div class="dimension"></div>
                <div class="player line"><span>{{playerA}}</span></div>
                <div class="player"><span>{{playerB}}</span></div>
            </div>
        </div>
        <div class="valueContainer">
            <div class="valueBox" v-for='item in data' :key='item.id'>
                <div class="dimension">{{item.dimension}}</div>
                <div class="player line"><span class="value">{{item.playerA}}</span><span class="unit">{{item.unit}}</span></div>
                <div class="player"><span class="value">{{item.playerB}}</span><span class="unit">{{item.unit}}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'overview',
    data (){
        return {
            playerA:'本季度',
            playerB:'全年',
            data:[
                {dimension:'上市新股',unit:'只',playerA:'18',playerB:'118'},
                {dimension:'一手平均盈亏',unit:'万',playerA:'60',playerB:'70'},
                {dimension:'平均超额认购倍数',unit:'倍',playerA:'120',playerB:'110'},
                {dimension:'平均中签率',unit:'%',playerA:'34',playerB:'63'},
                {dimension:'首日上涨比例',unit:'%',playerA:'76.76',playerB:'87.12'},
                {dimension:'首日平均涨跌幅',unit:'%',playerA:'50.76',playerB:'46.11'},
            ]
        }
    },
    methods: {
        getQuery: function (name) {
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            let r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            };
            return null;
        }
    },
    created(){
        let url = location.protocol+"//"+location.hostname+"/api/youyu-ipo-list/market-overview";
        this.$http.get(url,{params:{startDate:this.getQuery('startDate'),endDate:this.getQuery('endDate')}}).then((data)=>{
            console.log(data.data);
            this.playerA = data.data.data.playerA;
            this.playerB = data.data.data.playerB;
            this.data = data.data.data.data;
        })
    }
}
</script>

<style lang="scss" scoped>
.overview {
    display: flex;
    display: -webkit-flex;
    flex-wrap: nowrap;
    justify-content: center;
    margin-top: 0.50rem;
    padding: 0rem .3rem;
    overflow: hidden;
}

.playerContainer {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 16%;
}

.valueContainer {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 84%;
}

.playerBox {
    margin: 0.15rem 0rem;
}

.playerBox span {
    display: block;
    width: 1rem;
    height: .36rem;
    margin: 0.05rem 0rem;
    background: #F3F6FF;
    border-radius: .21rem;
}

.valueBox {
    flex: 1 0 30%;
    margin: .15rem 0rem;
}

.line {
    border-bottom: .01rem solid #BECCF5;
}

.dimension {
    height: .33rem;
    margin-bottom: .28rem;
    white-space:nowrap;
    font-family: 'Noto Sans SC',sans-serif;
    font-size: .24rem;
    font-weight: 500;
    color: #333333;
}

.player {
    height: 0.47rem;
    padding: .15rem 0rem;
}

.value {
    height: .47rem;
    font-family: DINAlternate;
    font-size: .4rem;
    font-weight: 700;
    color: #FF7A24;
}

.unit {
    font-family: 'Noto Sans SC',sans-serif;
    font-size: .2rem;
    font-weight: 400;
    color: #FF7A24;
}

</style>